import {balanceSvg as Icon__small__balanceSvg} from '../Icon__small/Icon__small--balance.js';

export var balance = {
  name: 'balance',
  category: 'icon',
  colorable: true,
  svg: Icon__small__balanceSvg,
};
